import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Extension } from '@clds/icon';
import { PrimaryMenuItem, PrimaryMenuItemProps } from '../../components/PrimaryMenu';
import { ADDON_PAGE_URL, MENU_ITEM_ICON_SIZE } from '../../ApplicationWrapper.const';
import { messages } from '../../i18n';
import { useCustomerIdContext } from '../../context';

export const AddonsPrimaryItem: FC<PrimaryMenuItemProps> = (props) => {
  const { formatMessage } = useIntl();
  const { currentCustomer } = useCustomerIdContext();

  return (
    <PrimaryMenuItem
      type="link"
      analyticsMessage="addons"
      analyticsAction="navigate"
      tooltipTitle={formatMessage(messages.addonsMenuTooltip)}
      href={currentCustomer && ADDON_PAGE_URL.replace('{customerId}', currentCustomer.externalIdForUrl)}
      data-test-specifier="add-ons button"
      {...props}
    >
      <Extension size={MENU_ITEM_ICON_SIZE} />
    </PrimaryMenuItem>
  );
};
